// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaInputQuestion from './view'

export default function TysiaInputQuestionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaInputQuestion">
      <TysiaInputQuestion {...props}>
        {children}
      </TysiaInputQuestion>
    </Flow>
  )
}
